<template>
    <b-card
        :title="this.translations.saveAlert[this.lang]"
        @cancel="$emit('close')"
        @submit="$emit('submit')"
        :disabled="false"
        :submit-text="{ el: 'OK', en: 'OK', it: 'OK' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
        :loading="loading"
    >
        <v-col cols="12" class="pr-2">
            {{ alertText }}
        </v-col>
    </b-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/pointTitles";

export default {
    name: "PointTierAlertDialog",

    mixins: [translations],

    props: {
        alertText: String
    },

    data() {
        return {};
    },
    computed: {
        ...mapState(["loading", "errorMessage"]),

        lang() {
            return this.$route.params.lang;
        }
    },
    methods: {}
};
</script>
